import classNames from 'classnames'

import { ApplicantDecisionAction } from '../ApplicantDecisionAction'

import * as styles from '../ApplicantDecisionPanel.module.css'

function ApplicantDecisionActions({ actions, className, onClick }) {
  return actions.length > 0 ? (
    <div className={classNames(styles.actions, className)}>
      {actions.map(action => (
        <ApplicantDecisionAction
          action={action}
          key={action.key}
          onClick={onClick}
        />
      ))}
    </div>
  ) : null
}

export default ApplicantDecisionActions
